import { render, staticRenderFns } from "./SolutionSheetItemPointLoad.vue?vue&type=template&id=351767cc&scoped=true&"
import script from "./SolutionSheetItemPointLoad.vue?vue&type=script&lang=js&"
export * from "./SolutionSheetItemPointLoad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351767cc",
  null
  
)

export default component.exports